export default "__VITE_ASSET__DVXe5kUq__"